import { HeroIcon } from '@components/HeroIcon'
import { Modal } from '@components/Modal'
import { useWhenShouldModalAdapt } from '@hooks/useWhenShouldModalAdapt'
import { TouchableOpacity } from 'react-native'
import { Text, XStack, YStack, styled } from 'tamagui'

interface IConfigsModalProps {
  open: boolean
  onClose: () => void
  openQualitySelector: () => void
  openSpeedSelector: () => void
  values: {
    quality: string
    speed: string
  }
}
export function ConfigsModal({
  open,
  onClose,
  values,
  openQualitySelector,
  openSpeedSelector,
}: IConfigsModalProps) {
  const { whenShouldAdapt } = useWhenShouldModalAdapt()
  return (
    <Modal
      onClose={onClose}
      open={open}
      snapPointsMode="constant"
      backdropOpacity={0.9}
      whenShouldAdapt={whenShouldAdapt ?? 'sm'}
    >
      <YStack
        marginTop="$spacing-inset-md"
        paddingHorizontal="$spacing-inset-xs"
        gap="$spacing-inset-md"
      >
        <TouchableOpacity
          onPressOut={() => {
            onClose()
            openQualitySelector()
          }}
        >
          <XStack justifyContent="space-between" alignItems="center">
            <XStack gap="$spacing-inset-nano" alignItems="center">
              <HeroIcon
                icon={['fal', 'sliders']}
                color="$neutral-800"
                size={24}
              />
              <ConfigItemText>Qualidade</ConfigItemText>
            </XStack>
            <ConfigItemValueText>{values.quality}</ConfigItemValueText>
          </XStack>
        </TouchableOpacity>
        <TouchableOpacity
          onPressOut={() => {
            onClose()
            openSpeedSelector()
          }}
        >
          <XStack justifyContent="space-between" alignItems="center">
            <XStack gap="$spacing-inset-nano" alignItems="center">
              <HeroIcon icon={'video-speed'} color="$neutral-800" size={24} />
              <ConfigItemText>Velocidade de reprodução</ConfigItemText>
            </XStack>
            <ConfigItemValueText>{values.speed}x</ConfigItemValueText>
          </XStack>
        </TouchableOpacity>
      </YStack>
    </Modal>
  )
}

export const ConfigItemText = styled(Text, {
  ff: '$mulishBold',
  fontSize: '$font-size-xs',
  color: '$neutral-800',
  fontWeight: 700,
})

export const ConfigItemValueText = styled(Text, {
  ff: '$mulishBold',
  fontSize: '$font-size-xxxs',
  color: '$neutral-500',
  fontWeight: 700,
})
